import React, { useContext, useEffect, useState, useRef } from "react";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonPage,
  IonTitle,
  IonToolbar,
  IonAvatar,
  IonText,
} from "@ionic/react";
import "./Tab3.css";
import "leaflet/dist/leaflet.css";
import axios from "../utils/axiosInstance";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import * as L from "leaflet";
import { AppContext } from "../context";
import { businessOutline, cafe, help, logOut, moon, sunny } from "ionicons/icons";
dayjs.extend(customParseFormat)

let DefaultIcon = L.icon({
  iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]    
});
L.Marker.prototype.options.icon = DefaultIcon;

type mapInfo = {
  lat: number,
  lng: number,
  showModal2: boolean
}

// not yet build
const LeafletMap: React.FC<mapInfo> = ({ lat, lng, showModal2}) => {
  let DefaultIcon = L.icon({
    iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]    
  });
  L.Marker.prototype.options.icon = DefaultIcon;
  const [map, setMap] = useState(Object);
  const mapRef = useRef<null | HTMLDivElement>(null);
  // const mapRef = useCallback(node => {
  //   console.log(node)
  //   const mymap = L.map(node,{
  //     attributionControl: true,
  //     zoom: 10,
  //   })
  //   .panTo([lat, lng]).setView([lat, lng], 18);
  //   L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //     // tileSize: 512,
  //     detectRetina: true,
  //     minZoom: 8,
  //     maxZoom: 18,
  //   }).addTo(mymap);
  //   new L.Marker([lat, lng]).addTo(mymap);    
  // },[lat, lng]);
  useEffect(() =>{
    console.log('useEffect',mapRef.current)
    const container = document.getElementById('map')
    console.log(container)
    if (mapRef.current && showModal2) {
      let mymap = L.map(mapRef.current,{
        attributionControl: true,
        zoom: 10,
      })
      .panTo([lat, lng]).setView([lat, lng], 18);   
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        // tileSize: 512,
        // detectRetina: true,
        minZoom: 8,
        maxZoom: 18,
      }).addTo(mymap);
      new L.Marker([lat, lng]).addTo(mymap);
      setMap(mymap)
    }
    return () => {
      if (map) console.log(map)
    }
  },[lat, lng, map, showModal2])
  return(
    <>
      <div ref={mapRef}  style={{ height: "300px", width: "100%" }} >
      </div>
    </>
  ); 
}

const Record: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [info, setInfo] = useState({
    address: '',
    punchTime: 0,
    type: '',
    lat: 0,
    lng: 0,
    otEnd: 0,
    otStart: 0,
    projectCode: "JWY",
    timelog: 0,
  });

  const hackToolbar = {
    height: "52px",
    paddingTop: "0px",
  };
  const hackTitle = {
    height: "52px",
  };
  const context: any = useContext(AppContext);

  const [timeRecords, setTimeRecords] = useState([]);

  function initMap() {
    console.log('initMap......')
    if (info.lat && info.lng) {
      const clockInMap = L.map("clockInMap",{
        attributionControl: true,
        zoom: 10,
      }).panTo([info.lat, info.lng]).setView([info.lat, info.lng], 18);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        // tileSize: 512,
        // detectRetina: true,
        minZoom: 8,
        maxZoom: 18,
      }).addTo(clockInMap);
      new L.Marker([info.lat, info.lng]).addTo(clockInMap);
    }
    else {
      
    }
  }

  const loadTimeRecords = () => {
    const memberId = window.localStorage.getItem('memberId')
    axios
      .get(`/gateway/private/core/v1/time-records/${memberId}`)
      .then(({data}) => {
        const records = data.info.items
        setTimeRecords(records);
        // console.log(data.info.items);
      });
  };

  useEffect(() => {
    loadTimeRecords();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function TypeIcon(props: { type: string; }) {
    const type = props.type.slice(2,3)
    if (type === '1') {
      return (<IonIcon color="primary" size="large" icon={businessOutline} />)
    }
    else if(type === '2') {
      return (<IonIcon color="danger" size="large" icon={logOut} />)
    }
    else {    
      return (<IonIcon size="large" icon={help} />)
    }
  }
  function TimeIcon(props: { type: string; }) {
    const time = props.type.slice(0,1)
    if (time === 'A') {
      return (<IonIcon size="large" icon={sunny} />)
    }
    else if (time === 'B') {
      return (
        <>
          <IonIcon size="large" icon={cafe} />
        </>
        )
    }
    else if (time === 'C') {
      return (<IonIcon size="large" icon={moon} />)
    }
    else {    
      return (<IonIcon size="large" icon={help} />)
    }
  }

  const timeRecordItems = () => {
    if (timeRecords.length > 0){
      return timeRecords.map((timeRecord: any) => {
        return (
          <IonItem key={timeRecord.idTimeRecords} button onClick={() => [setShowModal(true),setInfo(timeRecord)]}>
            <IonAvatar slot="start">
              <TypeIcon type={timeRecord.type}/>
            </IonAvatar>          
            <IonLabel>
              <h2>{ dayjs(timeRecord.punchTime, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format('YYYY-MM-DD 星期dd') }</h2>
              <div>打卡時間：{ dayjs(timeRecord.punchTime, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format('HH:mm:ss') }</div>
              {/* <div>下班打卡時間：{ dayjs.unix(timeRecord.clockOut).format('HH:mm:ss') }</div> */}
            </IonLabel>
          </IonItem>
        );
      });
    }
    else {
      return (
        <div className="ion-padding-horizontal">
          <IonText className="ion-text-center">
            <h1>尚無打卡紀錄</h1>
          </IonText>
        </div>
      )
    }
  };

  return (
    <IonPage>
      <IonHeader translucent={true}>
        <IonToolbar>
          <IonTitle>打卡記錄</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={true}>
        <IonHeader collapse="condense">
          <IonToolbar style={hackToolbar}>
            <IonTitle size="large" style={hackTitle}>
              打卡記錄
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <div className="ion-padding-horizontal">
          <IonButton onClick={loadTimeRecords}>重新整理</IonButton>
        </div>
        <IonList>
          {timeRecordItems()}
        </IonList>
      </IonContent>
      <IonModal
        isOpen={showModal}
        onDidPresent={() => initMap()}
        // onWillPresent={}  
      >
        <IonHeader translucent>
          <IonToolbar>
            <IonTitle>
            打卡資訊
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <IonCard>
            <IonCardHeader>
              <IonCardSubtitle>
                { dayjs(info.punchTime, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format('YYYY年MM月DD') }
              </IonCardSubtitle>
              <IonCardTitle>
                { info.type.slice(2,3) === '1' ? '上班': '下班'}時間
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent className="ion-text-center">
                <TimeIcon type={info.type} />
                <br />
                <IonLabel>
                  { dayjs(info.punchTime, 'YYYY-MM-DDTHH:mm:ss.000ZZ').format('HH:mm:ss')}
                </IonLabel>
              </IonCardContent>
            <IonCardHeader>
              <IonCardTitle>
                位置
              </IonCardTitle>
            </IonCardHeader>
            <IonItem>
              <IonLabel>
                <h2>經度</h2>
                <small>{ info.lng }</small>
              </IonLabel>
              <IonLabel>
                <h2>緯度</h2>
                <small>{ info.lat }</small>
              </IonLabel>
            </IonItem>
            <div
              id="clockInMap"
              className="ion-text-center"
              style={{ height: "300px", width: "100%" }}
            >
              無經緯度資料，無法顯示地圖。
            </div>
          </IonCard>
        </IonContent>
        <IonButton onClick={() => setShowModal(false)}>
          關閉詳細
        </IonButton>
      </IonModal>
    </IonPage>
  );
};

export default Record;
